import type { ReactNode } from 'react';

/** Centered card for sign-in and access requests (no app shell before sign-in). */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="grid min-h-dvh place-items-center bg-background p-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex items-center gap-2 font-semibold tracking-tight">
          <span aria-hidden="true" className="grid size-8 place-items-center rounded-md bg-primary text-primary-foreground">
            H
          </span>
          Hoopoe
        </div>
        <section aria-labelledby="auth-title" className="space-y-4 rounded-lg border bg-surface p-6 shadow-sm">
          <h1 id="auth-title" className="text-xl font-semibold">
            {title}
          </h1>
          {children}
        </section>
      </div>
    </main>
  );
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="text-sm text-danger-foreground">
      {message}
    </p>
  );
}
